export const STATUS_TYPE = {
  0: { text: '订单创建', color: 'primary' },
  1: { text: '订单完成', color: 'success' },
  2: { text: '订单审核中', color: 'warning' },
  3: { text: '订单审核通过', color: 'success' },
  4: { text: '用户已打款', color: 'info' },
  '-1': { text: '订单取消', color: 'danger' },
  '-2': { text: '超时取消', color: 'danger' },
  '-3': { text: '审核未通过', color: 'danger' }
};
export const TX_MAPS = {
  ETH: 'https://etherscan.io/tx/',
  BTC: 'https://btc.com/',
  USDT: 'https://www.omniexplorer.info/tx/'
};
